/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class EmitterManager {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    this.scene = scene;

    this.manager = this.scene.add.particles(ABCyaPhaser.Images.DEFAULT_ATLAS);
  }

  makeSmokePuff(x,y) {
    const smoke = {
      speedY: 40,
      frame: 'smoke-puff3',
      lifespan: { min: 400, max: 600 },
      alpha: { start: 1, end: 0 },
      scale: {
        onEmit: (particle) => {
          particle.scale = Phaser.Math.FloatBetween(0, .2);
          return particle.scale;
        },
        onUpdate: (particle, key, t, value) =>
          value + (t / 24)
      },
      rotate: {
        onEmit: (particle) => {
          particle.rand = Phaser.Math.Between(0, 1);
          return particle.rand;
        },
        onUpdate: (particle) => {
          if (particle.rand === 0) return particle.angle + 1;
          else return particle.angle - 1;
        },
      },
      emitZone: { source: new Phaser.Geom.Ellipse(0, 0, 162, 20) }
    };

    const emitter = this.manager.createEmitter(smoke);
    this.scene.add.existing(emitter.manager);
    emitter.explode(30, x, y);
  };

  sprayColor(x,y,color) {
    const colors = {
      blue: 0xaddddc,
      red: 0xf16d4b,
      green: 0xc8f264,
      yellow: 0xf4c662,
      purple: 0xd589b3,
      orange: 0xffa05f,
    };

    const data = {
      frame: ['paint_spatter+1', 'paint_spatter+2', 'paint_spatter+3'],
      lifespan: 600,
      accelerationY: { min: 420, max: 650 },
      accelerationX: { min: -200, max: 200 },
      scale: { start: 0, end: 2 },
      alpha: { start: 1, end: 0 },
      rotate: {
        onEmit: (particle) => {
          particle.rand = Phaser.Math.Between(0, 1);
          return particle.rand;
        },
        onUpdate: (particle) => {
          if (particle.rand === 0) return particle.angle + 1;
          else return particle.angle - 1;
        },
      },
      tint: colors[color],
      emitZone: { source: new Phaser.Geom.Rectangle(-50, -5, 100, 10) }
    };

    const emitter = this.manager.createEmitter(data);
    this.scene.add.existing(emitter.manager);
    emitter.explode(40, x, y);
  };

  showParty(x,y) {
    const frames = ['confetti+1', 'confetti+2', 'confetti+3', 'confetti+4', 'confetti+5','confetti+6'];
    for (let i = 0; i < 25; i++) {
      const particle = ABCyaPhaser.Images.addImage(x, y, frames[Phaser.Math.Between(0, frames.length - 1)], this.scene).setScale(Phaser.Math.FloatBetween(.7, 1));

      const path = new Phaser.Curves.Path(x, y).quadraticBezierTo(x + Phaser.Math.Between(-100, 100), y + Phaser.Math.Between(-200, -300), x, Phaser.Math.Between(-200, -300));
      ABCyaPhaser.Tweens.addTween(particle, 2000, { delay: 15 * i, angle: 360 * Phaser.Math.Between(1, 2) }, Phaser.Math.Easing.Linear);
      ABCyaPhaser.Tweens.addTween(particle, 500, { delay: 15 * i + Phaser.Math.Between(1000, 1500), alpha: 0 }, Phaser.Math.Easing.Sine.Out);
      ABCyaPhaser.Tweens.addPathTween(particle, path, 2000, { delay: 15 * i }, Phaser.Math.Easing.Sine.Out, () => {
        particle.destroy();
      });
    };
  };

  showJester(x,y) {
    const jester = {
      lifespan: 4000,
      speed: { min: 100, max: 200 },
      frame: ['confetti+1', 'confetti+2', 'confetti+3', 'confetti+4', 'confetti+5','confetti+6'],
      scale: { min: .5, max: .7 },
    };

    const emitter = this.manager.createEmitter(jester);
    this.scene.add.existing(emitter.manager);
    emitter.explode(30, x, y);
  }
}